import useSisenseDateRangeDropdown from "./UseSisenseDateRangeDropdown";

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import Constants from "@usas/ui-web/utils/Constants";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SisenseDateRangeDropdown = ({ label, name, value, error, message, onChange }) => {
  const { dateRangeOptions } = useSisenseDateRangeDropdown();

  return !dateRangeOptions.options
    ? <span className={global.LoadingMsg}>{Constants.LOADING_MSG}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={dateRangeOptions.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={!dateRangeOptions.options}
      />
    );
};

export default SisenseDateRangeDropdown;